/* eslint-disable no-param-reassign, no-underscore-dangle */
import { v4 as uuid } from 'uuid';
import useAxiosInstance from './composables/axiosInstance';
import useUISessionStore from '@/stores/ui-session';
import useFlashMessageStore from '@/stores/flash-messages';
const THIRTY_SECONDS = 1000 * 60 * 0.5;

useAxiosInstance.interceptors.request.use((request: any) => {
  const uiSessionStore = useUISessionStore();

  // Call keepAlive() before each backend request
  uiSessionStore.keepAlive();

  return {
    ...request,
    timeout: request.timeout ?? THIRTY_SECONDS,
    baseURL: uiSessionStore.backgroundWorkerURL,
    headers: {
      ...request.headers,
      Authorization: `Bearer ${uiSessionStore.token}`,
    },
  };
});

useAxiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const messageStore = useFlashMessageStore();
    const uiSessionStore = useUISessionStore();

    const { response, config, code, message } = error;

    // Handle network errors (no response object at all)
    if (!response) {
      messageStore.pushNotification({
        id: code || uuid(),
        type: 'error',
        duration: -1,
        title: 'Operation Failed.',
        message:
          code === 'ERR_NETWORK'
            ? 'The ConnX Background Worker doesn’t appear to be working properly. Please contact your internal ConnX Administrator.'
            : `Network error: ${message}`,
      });
      return Promise.reject(error);
    }

    // Handle HTTP errors safely
    const status = response?.status;

    if (status !== 401 || config._retry) {
      messageStore.pushNotification({
        id: uuid(),
        type: 'error',
        message: `${status}: ${message}`,
      });
      return Promise.reject(error);
    }

    // Retry flow for 401
    config._retry = true;
    await uiSessionStore.forceRefresh();
    useAxiosInstance.defaults.headers.common.Authorization = `Bearer ${uiSessionStore.token}`;

    return useAxiosInstance(config);
  }
);
